import { ModuleConfig } from '@/core/module';
import { invoiceConfigRoutes } from './routes';
import { useInvoiceConfigStore } from './stores/invoice-config-store';

export { useInvoiceConfig } from './hooks/useInvoiceConfig';
export * from './types';

export const InvoiceConfigModule: ModuleConfig = {
    name: 'invoice-config',
    routes: invoiceConfigRoutes,
    stores: {
        invoiceConfig: useInvoiceConfigStore
    },
    initialize: () => {
        console.log('Invoice Config module initialized');
    }
};
